import { useEffect, useState } from "react";

const ResponsiveHeroBackground = ({ children }) => {
  // Initialize with appropriate size immediately
  const getInitialBackground = () => {
    const width = window.innerWidth;
    if (width <= 768) return "url(/hero-bg-sm.webp)";
    if (width <= 1200) return "url(/hero-bg-md.webp)";
    return "url(/hero-bg.webp)";
  };

  const [backgroundImage, setBackgroundImage] = useState(
    getInitialBackground()
  );

  useEffect(() => {
    const updateBackground = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setBackgroundImage("url(/hero-bg-sm.webp)");
      } else if (width <= 1200) {
        setBackgroundImage("url(/hero-bg-md.webp)");
      } else {
        setBackgroundImage("url(/hero-bg.webp)");
      }
    };

    // Add event listener for window resize
    window.addEventListener("resize", updateBackground);

    // Cleanup
    return () => window.removeEventListener("resize", updateBackground);
  }, []);

  // WebP support detection
  const supportsWebP = () => {
    const canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    const ctx = canvas.getContext("2d");
    if (ctx) {
      return canvas.toDataURL("image/webp").indexOf("webp") > -1;
    }
    return false;
  };

  const getFallbackBackground = () => {
    if (!supportsWebP()) {
      return "url(/hero-bg.png)";
    }
    return backgroundImage;
  };

  return (
    <section
      id="hero"
      className="hero"
      style={{
        backgroundImage: getFallbackBackground(),
        backgroundSize: "cover",
        backgroundPosition: "center",
        fontFamily: "'EB Garamond', serif",
      }}
    >
      {children}
    </section>
  );
};

export default ResponsiveHeroBackground;
